<template>
  <!--
    Code By     : 陈伦刚
    CreateTime  : 2020-12-14 01:36:00
    Description :
  -->
  <div class="main page">
    <!-- <div class="box"></div> -->
    <div class="header">
      <div class="left">Gaia48作品</div>
      <div class="right">
        <div class="return" @click="goBack">
          <return theme="outline" />
          取消
        </div>
      </div>
    </div>
    <p class="statement">
      Gaiamount禁止发布任何违反相关法律法规的内容，您需确认拥有所提交内容的相关版权许可；投稿的请认真阅读Gaiamount
      相关分成条款与协议
    </p>
    <el-form
      ref="form"
      :model="form"
      :rules="rules"
      status-icon
      label-position="top"
    >
      <el-form-item label="标题" prop="title">
        <el-input v-model="form.title" autocomplete="off"></el-input>
      </el-form-item>
      <el-form-item label="基础信息" prop="info">
        <div class="input-group">
          <el-input
            v-model="form.number"
            placeholder="剧组编号"
            style="width: 31%"
          />
          <el-input
            v-model="form.director"
            placeholder="导演"
            style="width: 31%"
          />
          <el-select v-model="form.year" placeholder="年份" style="width: 31%">
            <el-option label="2019" value="2019"> </el-option>
            <el-option label="2020" value="2020"> </el-option>
            <el-option label="2021" value="2021"> </el-option>
          </el-select>
        </div>
      </el-form-item>
      <el-form-item label="所属地区" prop="areaId">
        <el-select
          v-model="form.area.id"
          placeholder="请选择"
          style="width: 100%"
        >
          <el-option
            v-for="(item, i) in addressList"
            :key="i"
            :label="`${item.text} | ${item.pinyin} | ${item.startTime} - ${item.endTime}`"
            :value="item.id"
          />
        </el-select>
      </el-form-item>
      <el-form-item label="创作人" prop="tags">
        <el-input
          v-model="peoples"
          :readonly="true"
          @focus="tagSelectVisible = true"
        ></el-input>
        <gaia48-people
          v-model="tagSelectVisible"
          :creatorList="form.creators"
          @change="
            (creators) => {
              form.creators = creators;
              peoples = JSON.stringify(creators);
            }
          "
        />
      </el-form-item>
      <el-divider></el-divider>
      <el-form-item label="封面（506px*960）" prop="pass">
        <upload-cover width="78px" :src="form.cover" @change="coverChange" />
      </el-form-item>
      <el-form-item label="短片介绍">
        <gaia-editor v-model="form.description" />
      </el-form-item>
      <el-form-item label="缘起">
        <gaia-editor v-model="form.story" />
      </el-form-item>
      <el-form-item label="剧本分镜">
        <gaia-editor v-model="form.script" />
      </el-form-item>
      <el-form-item>
        <el-checkbox v-model="access"> 上传即表示您已同意网站 </el-checkbox>
        <a
          class="pact"
          href="https://gaiamount.com/desktop/richPage?type=2"
          target="_blank"
        >
          《上传协议》
        </a>
      </el-form-item>
      <el-form-item>
        <el-button
          :disabled="!access"
          :loading="applyLoading"
          type="primary"
          @click="update48Works"
          style="width: 100%"
        >
          应用
        </el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import {
  getMaterialTags,
  getOwnMaterialTags,
  getUpdateMaterial,
  updateTemplateMaterial,
} from "@/api/material";
import { getOwnWork } from "@/api/personal";
import { update48Works } from "@/api/newgaia48";
import UploadCover from "@/components/upload/upload-cover";
import QuestionPrompt from "@/components/question-prompt/question-prompt";
import UploadFile from "@/components/upload/upload-file";
import GaiaEditor from "@/components/gaia-editor/gaia-editor";
import { Return } from "@icon-park/vue";
import { checkVerified, get48Addr } from "@/api/upload";
import tagSelect from "@/components/tag-select/tag-select";
import gaia48People from "@/components/gaia48-people/gaia48-people";
import { getAreas } from "@/api/newgaia48";
export default {
  components: {
    UploadCover,
    QuestionPrompt,
    UploadFile,
    GaiaEditor,
    Return,
    tagSelect,
    gaia48People,
  },
  data() {
    const info = (rule, value, callback) => {
      if (this.form.model == "") {
        callback(new Error("机型不能为空"));
      } else if (this.form.lens == "") {
        callback(new Error("镜头不能为空"));
      } else if (this.form.address == "") {
        callback(new Error("地点不能为空"));
      } else if (this.form.scene == "") {
        callback(new Error("拍摄不能为空"));
      } else if (this.form.software == "") {
        callback(new Error("基础信息不能为空"));
      } else {
        callback();
      }
    };
    const keyword = (rule, value, callback) => {
      if (this.form.keyword.split(";").length < 2) {
        callback(new Error("分类标签至少选择两个"));
      } else {
        callback();
      }
    };
    return {
      tagSelectVisible: false,
      id: "",
      contentType: "music",
      applyLoading: false,
      access: false,
      dialogVisible: false,
      form: {
        area: { id: null },
        acceptDonations: false,
        allowDownload: false,
        title: "",
        software: "",
        cover: "/web/img/material-music-cover.jpg",
        keyword: "",
        story: "",
        description: "",
        script: "",
        PoAgreementId: "",
        ReAgreementId: "",
        haveSetTime: false,
        time: [],
        fileFormat: "",
      },
      rules: {
        title: [
          {
            required: true,
            message: "请输入48作品名称",
            trigger: "blur",
          },
          {
            min: 4,
            max: 50,
            message: "长度在 4 到 50 个字符",
            trigger: "change",
          },
        ],
        info: [{ validator: info, trigger: "change", required: true }],
        allowDownload: [{ required: true }],
        keyword: [{ validator: keyword, required: true }],
        acceptDonations: [{ required: true }],
      },
      addressList: [],
      peoples: "",
    };
  },
  created() {
    this.id = this.$route.query.id;
    this.getAreas();
    this.getOwnWork();
  },
  methods: {
    /**
     * 分站区域
     */
    getAreas() {
      getAreas().then((res) => {
        this.addressList = res.areaList;
        this.form.areaId = res.areaList[0].id;
      });
    },
    get48Addr() {
      get48Addr().then((res) => {
        this.addressList = res.areas;
        this.form.areaId = res.areas[0].id;
      });
    },
    goBack() {
      window.history.go(-1);
    },
    getOwnWork() {
      getOwnWork(this.id)
        .then((res) => {
          this.form = res.hourWorks;
          this.peoples = JSON.stringify(
            res.hourWorks.creators.map((el) => {
              return {
                name: el.name,
                position: el.position,
                accountId: el.accountId,
              };
            })
          );
        })
        .catch((err) => {
          console.log(err);
          this.$message.error("获取48作品详情失败");
        });
    },
    update48Works() {
      let form = JSON.parse(JSON.stringify(this.form));
      form.creatorList = form.creators;
      form.areaId = form.area.id;
      form.detail = form.description;
      form.storyBoard = form.script;
      form.hourWorkId = form.id;
      delete form.video;
      delete form.user;
      delete form.area;
      update48Works(form)
        .then((res) => {
          console.log(res);
          this.$message.success("应用成功, 请等待审核");
        })
        .catch((err) => {
          console.log(err);
          this.$message.error("应用失败");
        });
    },
    update() {
      this.$refs["form"].validate((valid) => {
        if (valid) {
          if (!this.form.allowDownload) {
            const temp = JSON.parse(JSON.stringify(this.form));
            temp.type = this.contentType;
            if (temp.time === null) {
              temp.time = [];
            }
            updateTemplateMaterial(temp)
              .then((res) => {
                console.log(res);
                this.$message.success("应用成功, 请等待审核");
              })
              .catch((err) => {
                console.log(err);
                this.$message.error("应用失败");
              });
          }
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    /**
     * 封面改变
     */
    coverChange(cover) {
      this.form.cover = cover;
    },
  },
};
</script>
<style lang="less" >
// .index {
//   background: #f2f2f2;
// }
</style>
<style lang="less" scoped>
.main {
  // height: 1600px;
  padding-top: 100px;
  padding: 100px 150px 100px 150px;
  // background: #f2f2f2;
}
.box {
  height: 500px;
  background: #ffffff;
  box-sizing: border-box;
}
.header {
  width: 100%;
  margin: 0 auto;
  background: #e6e6e6;
  border-bottom: 2px solid #e45151;
  .left {
    display: inline-block;
    float: left;
    width: 50%;
    padding: 10px 20px 4px;
    text-align: left;
  }
  .right {
    display: inline-block;
    width: 50%;
    padding: 10px 20px 4px;
    text-align: right;
    .return {
      float: right;
      width: 100px;
      text-align: right;
      user-select: none;
      cursor: pointer;
    }
  }
}

.statement {
  font-size: 12px;
  color: #b2b2b3;
  margin: 20px 0px;
}

.input-group {
  div {
    // width: 22.3%;
    margin: 0 0 6px 3.5%;
  }
  div:nth-child(4n + 1) {
    margin-left: 0;
  }
}

.info-box {
  display: flex;
  .item {
    width: 22%;
  }
  .name {
  }
  .box {
    height: 40px;
    font-size: 12px;
    margin-right: 20px;
    padding-left: 10px;
    color: #909399;
    border: 1px solid #dcdcdc;
    cursor: pointer;
  }
}
</style>
